import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import HistoryPage from "@/pages/HistoryPage";
import SightsPage from "@/pages/SightsPage";
import BeachesPage from "@/pages/BeachesPage";
import DirectoryPage from "@/pages/DirectoryPage";
import TipsPage from "@/pages/TipsPage";
import GalleryPage from "@/pages/GalleryPage";
import MapPage from "@/pages/MapPage";
import MountainsPage from "@/pages/MountainsPage";
import AdvertisePage from "@/pages/AdvertisePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPage from "@/pages/AdminPage";
import SeoHead from "@/components/site/SeoHead";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/sights" element={<SightsPage />} />
        <Route path="/beaches" element={<BeachesPage />} />
        <Route path="/mountains" element={<MountainsPage />} />
        <Route path="/directory" element={<DirectoryPage />} />
        <Route path="/tips" element={<TipsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/advertise" element={<AdvertisePage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <SeoHead />
          <Shell />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}

export default App;
